module.exports = __webpack_public_path__ + "static/es-2076042cece9d4c6ad29cd76ad28054d.svg";